jQuery(document).ready(function ($) {
    /**
   * funcion para leer parametros get de la url actual
   */
    function getUrlParameter (sParam) {
        const sPageURL = window.location.search.substring(1)
        const sURLVariables = sPageURL.split('&')
        let sParameterName
        let i

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=')

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1])
            }
        }
        return false
    }

    /**
   * Start - Noticias
   */
    jQuery(".section-filter select[name='orderby']").on('change', function (e) {
        e.preventDefault()
        noticiasFilterAjax()
    })

    function noticiasFilterAjax () {
        const orderby = jQuery("select[name='orderby']").val()
        let url_completa = jQuery("input[name='url_home']").val()

        url_completa = url_completa.split('?')
        url_completa = url_completa[0]

        /* if (url_completa.indexOf("?") == -1) {
      url_completa = url_completa + '?orderby=' + orderby;
    } else {
      url_completa = url_completa + '&orderby=' + orderby;
    } */
        url_completa = url_completa + '?orderby=' + orderby

        noticiasAjaxProcess(url_completa)
    }

    $('.news .navigation .pagination').each(function () {
        $(this)
            .off('click', 'a.page-link')
            .on('click', 'a.page-link', function (e) {
                e.preventDefault()
                noticiasAjaxProcess(this.href)
                return false
            })
    })

    function noticiasAjaxProcess (href) {
        const elements = [
            // ".section-filter",
            '.grid-newCards',
            '.pagination',
            '.container-btn-view-more'
        ]

        // update browser history (IE doesn't support it)
        if (!navigator.userAgent.match(/msie/i)) {
            window.history.pushState({ state: href, rand: Math.random() }, '', href)
        }

        jQuery('#loading').removeClass('d-none')

        $.ajax({
            url: href,
            type: 'GET',
            headers: {
                HTTP_X_REQUESTED_WITH: 'XMLHttpRequest'
            },
            success: function (response, textStatus, jqXHR) {
                const $response = $('<div>').append($.parseHTML(response))
                // console.log($response.html());

                elements.forEach(function (element) {
                    if ($response.find(element).length) {
                        $(element).html($response.find(element).html())
                    } else {
                        $(element).empty()
                    }
                })

                jQuery('#loading').addClass('d-none')
                scrollToContainer('#grid-newCards')
                paginatorActive()
            },
            error: function () {
                window.location.reload()
            }
        })
    }

    function paginatorActive () {
        $('.page-item .current').each(function () {
            $(this).closest('.page-item').addClass('active')
        })
    }

    $('.news .container-btn-view-more').each(function () {
        $(this)
            .off('click', 'a.btn-view-more')
            .on('click', 'a.btn-view-more', function (e) {
                e.preventDefault()
                noticiasMobileAjaxProcess(this.href)
                return false
            })
    })

    function noticiasMobileAjaxProcess (href) {
        const elements = [
            '.grid-newCards'
        ]

        const remplaceElements = [
            '.container-btn-view-more'
        ]

        // update browser history (IE doesn't support it)
        if (!navigator.userAgent.match(/msie/i)) {
            window.history.pushState({ state: href, rand: Math.random() }, '', href)
        }

        jQuery('#loading').removeClass('d-none')

        $.ajax({
            url: href,
            type: 'GET',
            headers: {
                HTTP_X_REQUESTED_WITH: 'XMLHttpRequest'
            },
            success: function (response, textStatus, jqXHR) {
                const $response = $('<div>').append($.parseHTML(response))
                // console.log($response.html());

                elements.forEach(function (element) {
                    if ($response.find(element).length) {
                        $(element).append($response.find(element).html())
                    }
                })

                remplaceElements.forEach(function (element) {
                    if ($response.find(element).length) {
                        $(element).html($response.find(element).html())
                    } else {
                        $(element).empty()
                    }
                })

                jQuery('#loading').addClass('d-none')
                paginatorActive()
            },
            error: function () {
                window.location.reload()
            }
        })
    }

    // activa automaticamente la pagina del paginador actual en vista movil
    function sleep (ms) {
        return new Promise(resolve => setTimeout(resolve, ms))
    }
    async function paginadorNoticiasAutomatico () {
        const pages = getUrlParameter('pages')
        if (pages) {
            for (let i = 1; i <= pages; i++) {
                let url = window.location.href
                url = url.split('pages=')
                url = url[0] + 'pages=' + i
                console.log('pages: ' + url)
                noticiasMobileAjaxProcess(url)
                await sleep(1000)
            }
        }
    }
    if ($('main').hasClass('news') && window.matchMedia('(max-width: 767px)').matches) {
        const pages = getUrlParameter('pages')
        if (pages) {
            $('.grid-newCards').html('')
            paginadorNoticiasAutomatico()
        }
    }
    /**
   * End - Noticias
   */

    /**
   * Start - Search
   */
    $('.search .navigation .pagination').each(function () {
        $(this)
            .off('click', 'a.page-link')
            .on('click', 'a.page-link', function (e) {
                e.preventDefault()
                searchAjaxProcess(this.href)
                return false
            })
    })

    function searchAjaxProcess (href) {
        const elements = [
            '.grid-productCards',
            '.grid-newCards',
            '.pagination'
        ]

        // update browser history (IE doesn't support it)
        if (!navigator.userAgent.match(/msie/i)) {
            window.history.pushState({ state: href, rand: Math.random() }, '', href)
        }

        jQuery('#loading').removeClass('d-none')

        $.ajax({
            url: href,
            type: 'GET',
            headers: {
                HTTP_X_REQUESTED_WITH: 'XMLHttpRequest'
            },
            success: function (response, textStatus, jqXHR) {
                const $response = $('<div>').append($.parseHTML(response))
                // console.log($response.html());

                elements.forEach(function (element) {
                    if ($response.find(element).length) {
                        $(element).html($response.find(element).html())
                    } else {
                        $(element).empty()
                    }
                })

                jQuery('#loading').addClass('d-none')
                scrollToContainer('#grid-productCards')
                paginatorActive()
            },
            error: function () {
                window.location.reload()
            }
        })
    }
    /**
   * End - Search
   */

    /**
   * Start - Archive
   */
    $('.archive .navigation .pagination').each(function () {
        $(this)
            .off('click', 'a.page-link')
            .on('click', 'a.page-link', function (e) {
                e.preventDefault()
                archiveAjaxProcess(this.href)
                return false
            })
    })

    function archiveAjaxProcess (href) {
        const elements = [
            '.grid-newCards',
            '.pagination'
        ]

        // update browser history (IE doesn't support it)
        if (!navigator.userAgent.match(/msie/i)) {
            window.history.pushState({ state: href, rand: Math.random() }, '', href)
        }

        jQuery('#loading').removeClass('d-none')

        $.ajax({
            url: href,
            type: 'GET',
            headers: {
                HTTP_X_REQUESTED_WITH: 'XMLHttpRequest'
            },
            success: function (response, textStatus, jqXHR) {
                const $response = $('<div>').append($.parseHTML(response))
                // console.log($response.html());

                elements.forEach(function (element) {
                    if ($response.find(element).length) {
                        $(element).html($response.find(element).html())
                    } else {
                        $(element).empty()
                    }
                })

                jQuery('#loading').addClass('d-none')
                scrollToContainer('#grid-newCards')
                paginatorActive()
            },
            error: function () {
                window.location.reload()
            }
        })
    }
    /**
   * End - Archive
   */

    /**
     * Retorna la altura de la barra admin de wordpress
     */
    function getAdminBarHeight () {
        return 0

        const $admin_bar = $('#wpadminbar')
        const adminbar_height = ($admin_bar.is(':visible') && $admin_bar.css('position') == 'fixed') ? $admin_bar.outerHeight() : 0

        return parseInt(adminbar_height)
    }

    /**
   * Retorna la altura el header desktop
   */
    function getHeaderHeight () {
        const $header = jQuery('header.header.desktop')
        const header = $header.is(':visible') ? $header.outerHeight() : 200

        return parseInt(header)
    }

    /**
   * Permite hacer scroll a una div pasando como parametro el id o class
   */
    function scrollToContainer (container_id, timeout) {
        if (!jQuery(container_id).length) {
            return
        }

        if (!timeout) {
            timeout = 100
        }

        let containerScrollPosition = jQuery(container_id).offset().top - getAdminBarHeight() - getHeaderHeight() - 10
        if (containerScrollPosition < 0) {
            containerScrollPosition = 0
        }

        const currentScrollPosition = document.documentElement.scrollTop || document.body.scrollTop
        jQuery('html, body').stop().animate({ scrollTop: containerScrollPosition }, timeout)
    };

    /**
   * Click link footer a un id del DOM
   */
    $('.footer a').on('click', function () {
        const href = $(this).attr('href')
        if (href.indexOf('#') != -1) {
            let hash = href.split('#')
            hash = hash[1]
            scrollToContainer('#' + hash)
        }
    })
    if (window.location.hash) {
        setTimeout(function () {
            scrollToContainer(window.location.hash)
        }, 100)
    }
})
